import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import Loading from "./components/Loader/Loading";
import "./index.css";
import Logger from "./utils/Logger";

//import AppWrapper from "./AppWrapper";
Logger.Info(`<--- Interactive Books APP v${process.env.REACT_APP_VERSION} --->`);
const AppWrapper = React.lazy(() => import("./AppWrapper"));

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<Loading solid={true} />}>
			<AppWrapper />
		</Suspense>
	</React.StrictMode>,
	document.getElementById("root")
);

Logger.Info("Index rendered");

//import reportWebVitals from './reportWebVitals';
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
